import React from 'react';
import {
    TextField,
    Datagrid,
    Show,
    ArrayField,
    SimpleShowLayout,
    ReferenceField,
    DateField,
    Button,
    useRecordContext,
    useRedirect,
    List
} from 'react-admin';
import { SwList } from '../../lib/SwList';
import { useClosedStatusId } from '../../lib/useClosedStatusId';

const dateFormat = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
};

const courseVersionRowClick = (_id, _basePath, record) =>
    '/ThisSpecificCourseVersion/' + record.id;


const CourseVersionEditButton = ({ label, closedStatusId }) => {
    const record = useRecordContext();
    const redirect = useRedirect();

    const isEditable = record?.statusId !== closedStatusId;
    if (!isEditable) {
        return <></>;
    }

    const onClick = (e) => {
        e.stopPropagation();
        redirect('edit', 'ThisSpecificCourseVersion', record.id);
    };

    return <Button onClick={onClick}>{label}</Button>;
};


export const CourseVersionsShow = (props) => {
    const closedStatusId = useClosedStatusId();

    return (
        <Show {...props}>
            <SimpleShowLayout>
                <TextField source="id" />
                <ArrayField source="versions">
                        <Datagrid
                            rowClick={courseVersionRowClick}
                            bulkActionButtons={false}
                            >
                            <TextField source="version"/>
                            <TextField source="Title" />
                            <ReferenceField reference="Status" source="statusId">
                                <TextField source="Title" />
                            </ReferenceField>
                            <DateField
                                source="validationFrom"
                                options={dateFormat} />
                            <DateField source="validationTo" options={dateFormat} />
                            <DateField source="updated_at" options={dateFormat} />                                                       
                            <CourseVersionEditButton
                                label="Edit"
                                closedStatusId={closedStatusId} />
                        </Datagrid>
                </ArrayField>
            </SimpleShowLayout>
        </Show>
    );
};
